import Fuse from 'fuse.js';
import { useMemo, useCallback } from "react";

const useSearcher = (fields, data) => {
  const fieldsStr = JSON.stringify(fields);
  const searcher = useMemo(() => {
    return new Fuse(data, {
      tokenize: false,
      isCaseSensitive: false,
      shouldSort: false,
      findAllMatches: true,
      keys: fields,
      threshold: 0.2,
    });
  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldsStr, data]);

  const search = useCallback((query = '') => {
    if (typeof query !== 'string' || query === '') {
      return searcher._docs;
    }
    return searcher.search(query).map(i => i.item);
  }, [searcher]);

  const setData = useCallback((data = []) => {
    searcher.setCollection(data);
  }, [searcher]);

  return {
    search,
    setData,
  };
};

export default useSearcher;
